import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Badge from 'react-bootstrap/Badge';
import Container from 'react-bootstrap/Container';
import intersection from 'lodash/intersection';
import LocalizationContext from '../contexts/LocalizationContext';
import { getEnvironmentName, locationInPath } from '../utils/NavUtils';
import { GRAPH_API_REQUEST } from '../utils/GraphUtils';
import '../../css/LoruleNav.css';

var checkRole = function checkRole(userRoles, componentRoles) {
  return !componentRoles || intersection(userRoles, componentRoles).length > 0;
};

var getDropDownItems = function getDropDownItems(userDropDownItems, userRoles) {
  return userDropDownItems.filter(function (item) {
    return checkRole(userRoles, item.roles);
  }).map(function (item) {
    return /*#__PURE__*/React.createElement(NavDropdown.Item, {
      as: "button",
      onClick: item.onClick,
      "data-testid": item.testId,
      key: item.key
    }, item.item);
  });
};

var getAdditionalUserDropDownItems = function getAdditionalUserDropDownItems(userRoles, userDropDownItems) {
  if (userDropDownItems) {
    var elements = getDropDownItems(userDropDownItems, userRoles);

    if (elements.length > 0) {
      elements.push( /*#__PURE__*/React.createElement(NavDropdown.Divider, {
        key: "dropdown-elements-divider"
      }));
    }

    return elements;
  }

  return null;
};

var getAdditionalDropDownMenus = function getAdditionalDropDownMenus(userRoles, dropDownMenus) {
  if (dropDownMenus) {
    return dropDownMenus.filter(function (menu) {
      return checkRole(userRoles, menu.roles);
    }).map(function (menu) {
      return /*#__PURE__*/React.createElement(NavDropdown, {
        title: menu.title,
        id: menu.key,
        key: menu.key,
        "data-testid": menu.testId
      }, getDropDownItems(menu.items, userRoles));
    });
  }

  return null;
};

var LoruleNav = function LoruleNav(_ref) {
  var defaultPath = _ref.defaultPath,
      location = _ref.location,
      componentTabs = _ref.componentTabs,
      appName = _ref.appName,
      roles = _ref.roles,
      userInfo = _ref.userInfo,
      history = _ref.history,
      match = _ref.match,
      userConfig = _ref.userConfig,
      navHeaderCustom = _ref.navHeaderCustom,
      userDropDownItems = _ref.userDropDownItems,
      dropDownMenus = _ref.dropDownMenus;
  var localizedStrings = useContext(LocalizationContext);

  var _useMsal = useMsal(),
      instance = _useMsal.instance,
      inProgress = _useMsal.inProgress;

  var isAuthenticated = useIsAuthenticated();

  var getLoginElement = function getLoginElement() {
    var username = '';

    if (userInfo) {
      username = userInfo.displayName;
    }

    return isAuthenticated ? /*#__PURE__*/React.createElement(NavDropdown.Item, {
      as: "button",
      onClick: function onClick() {
        return instance.logoutRedirect();
      }
    }, "".concat(username, " (").concat(localizedStrings.lorule.logIn.out, ")")) : /*#__PURE__*/React.createElement(NavDropdown.Item, {
      as: "button",
      onClick: function onClick() {
        return instance.loginRedirect(_objectSpread({}, GRAPH_API_REQUEST));
      }
    }, localizedStrings.lorule.logIn.title);
  };

  var shouldRender = function shouldRender(componentRoles) {
    return !componentRoles || intersection(roles, componentRoles).length > 0;
  };

  var tabs = [];

  if (isAuthenticated && inProgress === InteractionStatus.None) {
    tabs = componentTabs.map(function (item) {
      if (item.roles === null || item.roles.length === 0 || intersection(roles, item.roles).length > 0) {
        var tabPath = item.components[0].path;

        if (item.components.length === 1) {
          // If there was only one item, display it as a tab
          var component = item.components[0];

          if (shouldRender(component.roles)) {
            var linkPath = component.entryPath ? component.entryPath : tabPath;
            return /*#__PURE__*/React.createElement(Nav.Link, {
              as: Link,
              to: linkPath,
              key: item.name,
              active: locationInPath(location.pathname, tabPath)
            }, item.item ? item.item : item.name);
          }
        }

        var dropdownRoutes = []; // If there was more than one item, it's a drop down

        var dropdownItems = item.components.map(function (component) {
          if (shouldRender(component.roles)) {
            dropdownRoutes.push(component.path);

            var _linkPath = component.entryPath ? component.entryPath : component.path;

            return /*#__PURE__*/React.createElement(NavDropdown.Item, {
              as: Link,
              to: _linkPath,
              key: component.name
            }, component.name);
          }

          return null;
        }); // Check to see if a route in the current tab matches the current location

        var active = false;
        dropdownRoutes.forEach(function (route) {
          if (locationInPath(location.pathname, route)) {
            active = true;
          }
        });
        return /*#__PURE__*/React.createElement(NavDropdown, {
          id: item.name,
          title: item.name,
          active: active,
          key: item.name
        }, dropdownItems);
      }

      return '';
    });
  }

  var environment = getEnvironmentName();

  if (environment) {
    environment = /*#__PURE__*/React.createElement(Badge, {
      id: "env-badge",
      variant: "warning",
      className: "text-light"
    }, environment);
  }

  var NavHeaderCustom = navHeaderCustom;
  return /*#__PURE__*/React.createElement(React.Fragment, null, NavHeaderCustom ? isAuthenticated && /*#__PURE__*/React.createElement(NavHeaderCustom, {
    appName: appName,
    defaultPath: defaultPath,
    componentTabs: componentTabs,
    roles: roles,
    userInfo: userInfo,
    history: history,
    location: location,
    match: match,
    userConfig: userConfig,
    dropDownMenus: dropDownMenus
  }) : /*#__PURE__*/React.createElement(Navbar, {
    id: "lorule-nav",
    "data-testid": "loruleNav",
    variant: "dark",
    className: "lorule-nav-bar",
    expand: "lg"
  }, /*#__PURE__*/React.createElement(Container, {
    fluid: true
  }, /*#__PURE__*/React.createElement(Navbar.Brand, {
    href: defaultPath,
    "data-testid": "logo-btn",
    as: Link,
    to: defaultPath
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("img", {
    className: "pr-2 d-none d-sm-inline-block mb-2",
    height: "30",
    alt: "Nintendo",
    src: require('../../assets/images/nintendo-logo-racetrack.svg')
  })), /*#__PURE__*/React.createElement("span", {
    id: "app-name"
  }, appName), " ", environment), /*#__PURE__*/React.createElement(Navbar.Toggle, {
    "aria-controls": "navbar-content"
  }), /*#__PURE__*/React.createElement(Navbar.Collapse, {
    id: "navbar-content"
  }, /*#__PURE__*/React.createElement(Nav, {
    className: "mr-auto"
  }, tabs), /*#__PURE__*/React.createElement(Nav, null, getAdditionalDropDownMenus(roles, dropDownMenus), /*#__PURE__*/React.createElement(NavDropdown, {
    title: /*#__PURE__*/React.createElement("i", {
      className: "fas fa-user fa-lg",
      "data-testid": "user-dropdown-btn"
    }),
    alignRight: true,
    id: "user-settings-dropdown",
    "data-testid": "user-dropdown"
  }, getAdditionalUserDropDownItems(roles, userDropDownItems), /*#__PURE__*/React.createElement(NavDropdown.Item, {
    as: Link,
    to: userConfig.path
  }, userConfig.name), /*#__PURE__*/React.createElement(NavDropdown.Divider, null), getLoginElement()))))));
};

export default LoruleNav;